module.exports = __webpack_public_path__ + "fonts/3107C8_5_0.d6e2013.woff2";